module.exports = __webpack_public_path__ + "001d129a9842e1dfadf4abd9905de8e8.jpg";